import { render, staticRenderFns } from "./fastFormLayout.vue?vue&type=template&id=3f07314f&"
import script from "./fastFormLayout.vue?vue&type=script&lang=js&"
export * from "./fastFormLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/layout/fastFormLayout.vue"
export default component.exports